/**
 * Team Section Component
 * Handles gradient animation at the bottom of the team section
 */
export class Team {
    constructor() {
        this.section = null;
        this.gradient = null;
        this.animation = null;
    }

    init() {
        this.section = document.querySelector(".no-main-team");
        if (!this.section) return;

        this.gradient = this.section.querySelector(".no-main-team__gradient");
        if (!this.gradient) return;

        // Register ScrollTrigger plugin
        if (
            typeof gsap !== "undefined" &&
            typeof ScrollTrigger !== "undefined"
        ) {
            gsap.registerPlugin(ScrollTrigger);
            this.initGradientAnimation();
        }
    }

    initGradientAnimation() {
        // Set initial opacity
        gsap.set(this.gradient, { opacity: 0 });

        // Create a master timeline for smooth, elegant animations
        const masterTimeline = gsap.timeline({ repeat: -1 });

        // Subtle floating animation - gentle horizontal movement
        masterTimeline.to(this.gradient, {
            x: "3%",
            duration: 12,
            ease: "sine.inOut",
        });

        // Subtle scale animation - breathing effect
        masterTimeline.to(
            this.gradient,
            {
                scaleX: 1.08,
                scaleY: 1.05,
                duration: 10,
                ease: "sine.inOut",
            },
            "<"
        );

        // Return to original position
        masterTimeline.to(this.gradient, {
            x: "-3%",
            scaleX: 0.95,
            scaleY: 0.98,
            duration: 14,
            ease: "sine.inOut",
        });

        masterTimeline.to(this.gradient, {
            x: "0%",
            scaleX: 1,
            scaleY: 1,
            duration: 12,
            ease: "sine.inOut",
        });

        // ScrollTrigger animation - fade in and animate on scroll
        ScrollTrigger.create({
            trigger: this.section,
            start: "top 85%",
            end: "bottom 15%",
            onEnter: () => {
                gsap.to(this.gradient, {
                    opacity: 1,
                    duration: 2,
                    ease: "power2.out",
                });
            },
            onLeave: () => {
                gsap.to(this.gradient, {
                    opacity: 0.7,
                    duration: 1.5,
                    ease: "power2.in",
                });
            },
            onEnterBack: () => {
                gsap.to(this.gradient, {
                    opacity: 1,
                    duration: 2,
                    ease: "power2.out",
                });
            },
            onLeaveBack: () => {
                gsap.to(this.gradient, {
                    opacity: 0,
                    duration: 1.5,
                    ease: "power2.in",
                });
            },
        });

        // Store animation reference
        this.animation = masterTimeline;
    }

    destroy() {
        if (this.animation) {
            this.animation.kill();
        }
        ScrollTrigger.getAll().forEach((trigger) => {
            if (trigger.vars.trigger === this.section) {
                trigger.kill();
            }
        });
    }
}
